<template lang="pug">
  div
    el-table(
      :data="dados"
      style="width: 100%"
    )
      el-table-column(
        label='Processo'
        prop="numeroProcesso"
        width="130"
        fixed
      )
      el-table-column(
        label='Interessado',
        prop="nomeRazaoSocialInteressado"
        width="200"
        fixed
      )
      el-table-column(
        label='CPF',
        prop="cpfCnpjInteressado"
        width="130"
      )
      el-table-column(
        label='Ordem de serviço'
        prop="ordensServico"
        width="180"
      )
      el-table-column(
        label='Município'
        prop="municipioFormatado"
        width="100%"
      )
      el-table-column(
        label='Endereço',
        prop="loteamentoVila"
        width="200"
      )
      el-table-column(
        label='Bairro'
        prop="bairro"
        width="130"
      )
      el-table-column(
        label='Lote'
        width="100%"
        prop="lote"
      )
      el-table-column(
        label='Quadra'
        prop="quadra"
      )
      el-table-column(
        label='Cadastrante',
        prop="cadastrante"
        width="200"
      )
      el-table-column(
        label='Perfil do cadastrante'
        prop="perfilCadastrante"
        width="155"
      )
      el-table-column(
        label='Data',
        prop="dataFormatada"
        width="100%"
        align='center'
      )
      el-table-column(
        label='Ações'
        align='center'
        width='100%'
        fixed="right"
      )
        template(slot-scope='scope')
          el-dropdown(trigger="click")
            el-button(type='primary', size="small")
              | Ações
              i.el-icon-arrow-down.el-icon--right
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item
                .flex(@click="abreModal(scope.row)")
                  i.fa.fa-eye
                  | &nbsp Visualizar processo
              el-dropdown-item
                .flex(@click="downloadPdf(scope.row)")
                  i.fal.fa-download
                  | &nbsp Baixar PDF
    app-modal-visualizar-completo(
      v-if="showModalVisualizarProcesso",
      @closeModal="showModalVisualizarProcesso = false",
      :idProcesso="idProcesso",
      :protocolo="protocolo",
      :numeroProcesso="numeroProcesso",
      :tipo="tipoProcesso"
    )
</template>

<script>
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import { mapActions } from 'vuex'

export default {
  name: 'ListagemProcesso',
  props: {
    dados: {
      required: true
    }
  },
  components: {
    AppModalVisualizarCompleto
  },

  data () {
    return {
      showModalVisualizarProcesso: false,
      idProcesso: null,
      protocolo: null,
      numeroProcesso: null,
      tipoProcesso: null
    }
  },

  methods: {
    ...mapActions({
      baixarPdfProcesso: 'processos/baixarPdfProcesso'
    }),

    abreModal (row) {
      this.idProcesso = row.id
      this.protocolo = row.numeroProtocolo
      this.numeroProcesso = row.numeroProcesso
      this.showModalVisualizarProcesso = true
      this.tipoProcesso = row.tipo
    },

    async downloadPdf (row) {
      const idProcesso = row.id
      await this.baixarPdfProcesso(idProcesso)
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .el-tabs--border-card {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_reurb/components/ListagemProcesso.vue